import {
  ICheckboxListFilter,
  IDateRangeFilter,
  IRadioButtonListFilter,
  ITextInputFilter,
  MultiFilterType,
} from './interfaces';
import { ITypeaheadFilter, ITypeaheadService } from '.';

export function createDefaultLocationFilterConfig(
  typeaheadService: ITypeaheadService,
): ITypeaheadFilter {
  return {
    id: 'locationIds',
    headingText: 'Location',
    type: MultiFilterType.LocationTypeahead,
    isExpanded: true,
    typeaheadService: typeaheadService,
  };
}

export function createDefaultPositionFilterConfig(
  typeaheadService: ITypeaheadService,
): ITypeaheadFilter {
  return {
    id: 'positionIds',
    headingText: 'Position',
    type: MultiFilterType.PositionTypeahead,
    isExpanded: true,
    typeaheadService: typeaheadService,
  };
}

export function createEmptyCheckboxFilterConfig(): ICheckboxListFilter {
  return {
    id: 'cbl',
    headingText: 'CheckboxList',
    type: MultiFilterType.CheckboxList,
    isExpanded: true,
    options: [],
  };
}

export function createEmptyRadioButtonFilterConfig(): IRadioButtonListFilter {
  return {
    id: 'rb1',
    headingText: 'RadioButtonList',
    type: MultiFilterType.RadioButtonList,
    isExpanded: true,
    options: [],
    defaultOption: null,
  };
}

export function createDefaultTextboxConfig(): ITextInputFilter {
  return {
    id: 'ti',
    headingText: 'Text Input',
    type: MultiFilterType.TextInput,
    isExpanded: true,
    inputHint: 'Search Hint',
    inputLabel: 'Search Label',
  };
}

export function createDefaultDateRangeConfig(): IDateRangeFilter {
  return {
    id: 'dr',
    headingText: 'Date Range',
    type: MultiFilterType.DateRange,
    isExpanded: true,
    presetDates: [],
  };
}
